
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`newsletters/index`),
    update: (id, userData) => clientAuth.post(`newsletters/update/${id}`, { json: userData }),
    destroy: (id) => clientAuth.delete(`newsletters/destroy/${id}`),
    
    show: (id) => clientAuth.get(`newsletters/show/${id}`),

    updatenewsletter: (id) => clientAuth.post(`notification/newsletter/update/${id}`),
    updatestatus: (payload) => clientAuth.post(`customer/database-status/update`, {json: payload}),


};